module.exports = __webpack_public_path__ + "img/step1_1.eb1fb8f7.jpg";